import React from 'react'
import styles from './promocionBanner.module.scss'
import RegaloIcon from './assets/regalo_icon.svg'
import { textWithLocaleAndDefault } from '../../../../../../common/i18n'

export interface Promocion {
  texto_promociones: string
  texto_promociones_ca: string
  color_background: string
  color_texto: string
  visible_cesta: boolean
}

interface PromotionBannerProps {
  promocion: Promocion
}

export const PromocionBanner = ({ promocion }: PromotionBannerProps) => {
  const bannerStyles = {
    backgroundColor: promocion.color_background,
    color: promocion.color_texto,
  }
  return (
    <div className={styles.promobanner} style={bannerStyles}>
      <RegaloIcon />
      {textWithLocaleAndDefault('texto_promociones', promocion)}
    </div>
  )
}
